module.exports = __webpack_public_path__ + "img/history_icon.ff8aa611.svg";